// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1hl1I","signatureButtonsRight":"ModalSign_signatureButtonsRight__3p6sT"};